import _objectSpread from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { __decorate } from "tslib";
import path from 'path';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { isExternal } from '@/utils/validate';
import SidebarItemLink from './SidebarItemLink.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "item", void 0);
    _defineProperty(_this, "isCollapse", void 0);
    _defineProperty(_this, "isFirstLevel", void 0);
    _defineProperty(_this, "basePath", void 0);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "alwaysShowRootMenu",
    get: function get() {
      if (this.item.meta && this.item.meta.alwaysShow) {
        return true;
      }
      return false;
    }
  }, {
    key: "showingChildNumber",
    get: function get() {
      if (this.item.children) {
        var showingChildren = this.item.children.filter(function (item) {
          if (item.meta && item.meta.hidden) {
            return false;
          } else {
            return true;
          }
        });
        return showingChildren.length;
      }
      return 0;
    }
  }, {
    key: "theOnlyOneChild",
    get: function get() {
      if (this.showingChildNumber > 1) {
        return null;
      }
      if (this.item.children) {
        var _iterator = _createForOfIteratorHelper(this.item.children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            if (!child.meta || !child.meta.hidden) {
              return child;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      // If there is no children, return itself with path removed,
      // because this.basePath already conatins item's path information
      return _objectSpread(_objectSpread({}, this.item), {}, {
        path: ''
      });
    }
  }, {
    key: "resolvePath",
    value: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    }
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], default_1.prototype, "item", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isCollapse", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "isFirstLevel", void 0);
__decorate([Prop({
  default: ''
})], default_1.prototype, "basePath", void 0);
default_1 = __decorate([Component({
  // Set 'name' here to prevent uglifyjs from causing recursive component not work
  // See https://medium.com/haiiro-io/element-component-name-with-vue-class-component-f3b435656561 for detail
  name: 'SidebarItem',
  components: {
    SidebarItemLink: SidebarItemLink
  }
})], default_1);
export default default_1;